import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export function Logo({ disabledLink = false, sx }) {
  const logo = <Box component="img" src="/static/cwr-icon.png" sx={{ width: 40, height: 40, ...sx }} />

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
export function LogoPromotive({ disabledLink = false, sx }) {
  const logo = <Box component="img" src="/static/logo-promotive.png" sx={{ maxWidth: '100%', ...sx }} />

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
